export default __webpack_public_path__ + "static/media/maranata_2.8ef5e31e.jpg";